
<template>
  <!-- TODO: Se oculta seccion de Idioma hasta que este finalizado -->
  <div
    id="app"
    :class="{ 'not-logged-in': !isLoged, 'has-rail': showRail }"
    :lang="$i18n.locale"
  >
    <!-- <div id="app" :class="{ 'not-logged-in': !isLoged }" lang="es"> -->
    <!-- :class="{
        'custom-margin-bottom': app_name == 'KEY LEARNING' && !isLoged,
      }" 
      mt-4-->

    <div class="section1" id="mainsection">
      <go-top
        :right="17"
        :z-index="500"
        title="Ir al tope de la página"
        :boundary="gotop_boundary"
        :radius="50"
        class="noprint"
      ></go-top>

      <new-nav-bar />
      <!-- <nav-bar /> -->
      <Menu class="my-0" />
      <main id="page-wrap" :class="{ 'router-container': isLoged }">
        <div v-if="isLoged" class="div-header">
          <template v-if="!curricularMeshDuocLogo">
            <b-img
              v-if="isLoged && institution_logo"
              v-bind:src="institution_logo"
              class="logo-print"
            ></b-img>
          </template>
          <template v-else>
            <b-img
              v-if="isLoged"
              v-bind:src="
                require('@/assets/logos/curricular_mesh_duoc_logo.png')
              "
              class="logo-print-curricular-mesh"
            ></b-img>
            <!-- v-bind:src="@" -->
          </template>
        </div>
        <b-container class="app-container pt-0">
          <!-- style="padding-left: 0 !important; padding-right: 0 !important" -->
          <router-view></router-view>
        </b-container>
      </main>
    </div>
    <toolbar-component class="noprint" v-if="showRail"></toolbar-component>
    <NewFooter></NewFooter>
    <!-- Silent update: solo visible en el camino forzado (--force-update) -->
    <update-banner />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { expirationTime, EventBus, isValidJwt } from "@/utils/utils";
import { APP_NAME } from "@/utils/globals";
import NewNavBar from "@/components/new-page/NavBar";
import NewFooter from "@/components/public/NewFooter";
import toolbar from "@/components/public/Toolbar";
import * as names from "@/store/names";
import GoTop from "@inotom/vue-go-top";

export default {
  components: {
    NewNavBar,
    // NavBar,
    NewFooter,
    "toolbar-component": toolbar,
    "go-top": GoTop,
  },
  data() {
    return {
      loading: false,
      loading_value: 0,
      loading_max: 0,
      gotop_boundary: 100,
      app_name: APP_NAME,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      isLoged: "isLoged",
      institution: "getInstitution",
      institution_logo: "getInstitutionLogo",
      // TODO: Se oculta seccion de Idioma hasta que este finalizado
      userLanguage: names.USER_LANGUAGE,
    }),
    canViewToolbar() {
      if (
        this.user &&
        this.user.group_names.includes("ESTUDIANTES") &&
        !this.user.is_superuser
      )
        return false;
      else return true;
    },
    // El riel de navegación se muestra a todo usuario logueado (las secciones
    // que correspondan se filtran dentro del propio componente según permisos).
    showRail() {
      return this.isLoged && !!this.user;
    },
    curricularMeshDuocLogo() {
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.$route.name == "CurricularMeshView"
      )
        return true;
      return false;
    },
  },
  methods: {
    launchAlertTimeout() {
      // SEC-3 fase 2: el token vive solo en memoria (Vuex), no en localStorage.
      if (this.$store.state.jwt_token) {
        // Computamos el tiempo restante del token y le restamos 15 segundos,
        // el formulario estara activo por 10 segundos, los restantes 5
        // segundos son el margen para que la peticion se ejecute.
        // Si el token expira, en getters.isLoged eliminara toda la data del
        // storage aunque se refresque el token y eso lo queremos evitar.
        // Por lo tanto el token debera ser valido todo el tiempo.
        const time_to_launch_modal =
          expirationTime(this.$store.state.jwt_token) - 15000;
        const time_modal_alive = 10000;
        setTimeout(() => {
          if (!isValidJwt(this.$store.state.jwt_token)) {
            return;
          }
          this.$swal
            .fire({
              title: "Su sesión va a expirar pronto",
              text: "¿Desea seguir navegando?",
              type: "question",
              timer: time_modal_alive,
              allowEscapeKey: false,
              allowOutsideClick: false,
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: "Si",
              cancelButtonText: "No",
              preConfirm: () => {
                // updateToken ahora propaga el fallo (lo maneja el timer de
                // mounted); aquí basta con tragarlo para evitar el warning.
                this.$store.dispatch("updateToken").catch(() => {});
              },
            })
            .then((result) => {
              if (result.dismiss === "timer") {
                // El usuario no seleciona nada.
                // Volvemos a establecer el timeOut en caso de que haya
                // renovado en otra pagina.
                if (
                  expirationTime(this.$store.state.jwt_token) - 15000 >
                  time_modal_alive
                ) {
                  // console.log("Reestableciendo tiempo de expiracion.");
                  this.launchAlertTimeout();
                }
              } else if (result.dismiss === "cancel") {
                // El usuario no revova el token.
                this.$logOut();
              }
            });
        }, time_to_launch_modal);
      }
    },
    launchExpirationModal() {
      this.$swal.fire({
        title: "Su sesión ha expirado",
        text: "Se ha agotado el tiempo de sesión.",
        type: "info",
        allowEscapeKey: true,
        allowOutsideClick: true,
        showConfirmButton: true,
        showCancelButton: false,
      });
    },
  },
  watch: {
    $route(to) {
      if (this.isLoged && to.name == "ResetPassword")
        this.$router.push({ name: "DashboardView" });
      // TODO: Se agregó por el momento para evitar que, al estar logeado,
      // pueda ir al welcome.
      else if (this.isLoged && to.name == "Welcome")
        this.$router.push({ name: "DashboardView" });
    },
    isLoged(newVal) {
      if (newVal) {
        // El idioma se resuelve en resolveUserLanguage (store action)
        // que se ejecuta al cargar la institución del usuario.
        this.$store.dispatch(names.FETCH_ALTERNATIVE_NAMES);
        this.$store.dispatch(names.FETCH_TAXONOMIES);
        this.$store.dispatch(names.FETCH_CYCLES);
        this.$store.dispatch(names.FETCH_CAMPUSES);
        this.$store.dispatch(names.FETCH_COMPETENCE_TYPES);
        this.$store.dispatch(names.FETCH_FACULTIES);
        this.$store.dispatch(names.FETCH_INSTRUCTIVES).then((response) => {
          response.forEach((instructive) => {
            this.$store.dispatch(names.FETCH_FILE, instructive.file);
          });
        });
        this.$store.dispatch(names.FETCH_FORMATION_AREAS);
        this.$store.dispatch(names.FETCH_MODALITIES);
        this.$store.dispatch(names.FETCH_SHIFTS);
        this.$store.dispatch(names.FETCH_PERIODS);
        this.$store.dispatch(names.FETCH_REGIMES);
      } else {
        // Al cerrar sesión, restaurar el idioma público
        const publicLang = localStorage.getItem("public_language") || "es";
        this.$i18n.locale = publicLang;
      }
    },
    // TODO: Se oculta seccion de Idioma hasta que este finalizado
    // Sincronizar cambios de idioma entre Vuex store y vue-i18n
    userLanguage(newLang) {
      if (this.$i18n.locale !== newLang) {
        this.$i18n.locale = newLang;
      }
    },
    // La página declara el idioma de la interfaz, así el navegador no la traduce sola
    "$i18n.locale": {
      handler(lang) {
        document.documentElement.lang = lang;
      },
      immediate: true,
    },
  },
  created() {
    if (APP_NAME == "GERA") {
      import("./utils/styles_gera.css");
    } else {
      import("./utils/styles_kl.css");
    }
    if (APP_NAME) document.title = APP_NAME;
    const logo = this.$logo;
    if (logo) document.icon = logo;

    // TODO: Se oculta seccion de Idioma hasta que este finalizado
    // Detectar idioma del navegador si no hay idioma público guardado
    if (!localStorage.getItem("public_language")) {
      const browserLang = navigator.language || navigator.userLanguage;
      const langCode = browserLang.split("-")[0];
      const detectedLang = langCode === "en" ? "en" : "es";
      localStorage.setItem("public_language", detectedLang);
    }

    // Sincronizar idioma según estado de login
    if (this.isLoged) {
      const userLang = localStorage.getItem("user_language") || "es";
      this.$i18n.locale = userLang;
      this.$store.commit(names.SET_USER_LANGUAGE, userLang);
      this.$store.dispatch(names.FETCH_LANGUAGES);
    } else {
      const publicLang = localStorage.getItem("public_language") || "es";
      this.$i18n.locale = publicLang;
    }

    EventBus.$on("loadStarted", () => {
      this.loading = true;
    });
    EventBus.$on("loadFinished", () => {
      this.loading = false;
    });
    EventBus.$on("increment", (max) => {
      this.loading_max = max;
    });
    EventBus.$on("decrement", (value) => {
      this.loading_value = value;
    });
  },
  mounted() {
    clearInterval();
    // Set up a timer to check the token's expiration time periodically
    setInterval(() => {
      // SEC-3 fase 2: el token vive solo en memoria (Vuex), no en localStorage.
      const token = this.$store.state.jwt_token;
      // Sin sesión no hay nada que vigilar (y logOut ahora siempre llama al
      // backend — evitamos 401 periódicos para visitantes anónimos).
      if (!token && !this.isLoged) return;
      // Multi-pestaña (SEC-4 + SEC-5): en una pestaña inactiva el access token
      // (30 min) expira sin que el interceptor de api.js lo refresque. La
      // sesión real sigue viva en la cookie HttpOnly, así que se intenta un
      // silent refresh. NUNCA llamar $logOut() desde este timer: revoca TODOS
      // los refresh tokens del usuario (must_relog) y cerraba la sesión de las
      // otras pestañas/dispositivos activos.
      let token_expired = false;
      try {
        token_expired = !isValidJwt(token);
      } catch (error) {
        token_expired = true;
      }
      if (token_expired && this.isLoged) {
        this.$store.dispatch("updateToken").catch(() => {
          // Cookie vencida o blacklisteada: updateToken ya limpió la sesión
          // local (clearLoginData). Avisar y volver al inicio.
          this.launchExpirationModal();
          if (this.$route.name !== "Welcome")
            this.$router.push({ name: "Welcome" });
        });
      }
    }, 60000); // Check every x minutes (60000 * x)
    // this.launchAlertTimeout();

    // Para que cuando actualicen la página se guarden los alternative_names .
    // del local_storage al store.
    if (this.isLoged) this.$store.dispatch(names.FETCH_ALTERNATIVE_NAMES);
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inclusive+Sans&display=swap");
:root {
  -webkit-print-color-adjust: exact !important;
}
.btn:focus,
.btn.focus {
  /*Estilo para quitar el borde del boton cuando se selecciona*/
  -webkit-box-shadow: none !important;
  /*Estilo para quitar el borde del boton cuando se selecciona*/
  box-shadow: none !important;
  transform: scale(0.99);
}
.primary-color {
  background-color: var(--primary-color) !important;
  color: var(--primary-font-color) !important;
}
.secondary-color {
  background-color: var(--secondary-color) !important;
  color: var(--primary-font-color) !important;
}
.primary-font-size {
  font-size: var(--primary-font-size);
}
.secondary-font-size {
  font-size: var(--secondary-font-size);
}
.thirth-font-size {
  font-size: var(--thirth-font-size);
}
.primary-button {
  background-color: var(--primary-color) !important;
  color: var(--primary-font-color) !important;
}
.primary-button:hover {
  background-color: var(--primary-hover-color) !important;
  color: var(--primary-font-color) !important;
}
.secondary-button {
  background-color: var(--secondary-color) !important;
  color: var(--secondary-font-color) !important;
}
.secondary-button:hover {
  background-color: var(--secondary-hover-color) !important;
  color: var(--secondary-font-color) !important;
}
.btn-primary,
.btn-secondary,
.btn-danger {
  color: var(--secondary-font-color) !important;
}
#app {
  /* Tipografía y color base de la app según el estándar (styles_kl.css). */
  font-family: var(--kl-font-family);
  color: var(--kl-text-body);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding-top: 66px;
  /* clip (y no hidden): hidden convierte a #app en contenedor de scroll y
  rompe position:sticky en todos sus descendientes (ej. breadcrumb). */
  overflow: clip;
}
.not-logged-in {
  padding-top: 49px !important;
}
/* Cuando existe el riel de navegación izquierdo, desplazamos el contenido y
el navbar para dejarle su columna fija (ancho del riel colapsado: 60px). */
.has-rail {
  padding-left: 60px;
  transition: padding-left 0.22s ease;
}
.has-rail #nav-bar {
  left: 60px !important;
  transition: left 0.22s ease;
}
.has-rail .loadingBar {
  left: 60px !important;
  width: calc(100% - 60px) !important;
}
/* Riel expandido (248px): empujamos el layout en vez de superponer. */
body.kl-rail-expanded .has-rail {
  padding-left: 248px;
}
body.kl-rail-expanded .has-rail #nav-bar {
  left: 248px !important;
}
body.kl-rail-expanded .has-rail .loadingBar {
  left: 248px !important;
  width: calc(100% - 248px) !important;
}
/* En móvil el riel no reserva columna: solo flota el botón "grid" y el menú
se superpone. El navbar libera espacio a la izquierda para el botón. */
@media (max-width: 768px) {
  .has-rail {
    padding-left: 0;
  }
  .has-rail #nav-bar {
    left: 0 !important;
    padding-left: 60px;
  }
  .has-rail .loadingBar {
    left: 0 !important;
    width: 100% !important;
  }
  body.kl-rail-expanded .has-rail {
    padding-left: 0;
  }
  body.kl-rail-expanded .has-rail #nav-bar {
    left: 0 !important;
  }
  body.kl-rail-expanded .has-rail .loadingBar {
    left: 0 !important;
    width: 100% !important;
  }
  /* Navbar logueado en 2 filas: fila 1 = logo (+ botón grid flotante a la
  izquierda); fila 2 = controles (impresión, idioma, modo edición, usuario). */
  #app.has-rail {
    padding-top: 98px;
  }
  .has-rail #nav-bar {
    flex-wrap: wrap;
    height: auto;
    padding-top: 6px;
    padding-bottom: 8px;
    row-gap: 4px;
  }
  .has-rail #nav-bar .brand-section {
    flex: 1 1 auto;
  }
  /* Logo más compacto en responsive (cap de ancho y alto) para que no ocupe
  tanto. Quitamos los mínimos para que escale libre manteniendo proporción. */
  #nav-bar .logo {
    max-height: 40px !important;
    max-width: 130px !important;
    min-height: 0 !important;
    min-width: 0 !important;
  }
  .has-rail #nav-bar .user-info-container {
    flex-basis: 100%;
    width: 100%;
    margin: 0 !important;
  }
  /* La fila 2 ocupa el 100% y reparte los 4 controles sin solaparse */
  .has-rail #nav-bar .navbar-nav {
    width: 100% !important;
    float: none !important;
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    justify-content: center !important;
    white-space: normal !important;
    gap: 12px;
  }
  /* El usuario sube a la fila 1, arriba a la derecha junto al logo */
  .has-rail #nav-bar .dropdown-adjustment {
    position: absolute;
    top: 12px;
    right: 12px;
    margin: 0 !important;
  }
  /* Fila 2 (orden): modo edición · impresión · idioma. Grupo centrado y
  equiespaciado con gap parejo (no márgenes en em) para que se vea igual en
  cualquier ancho. Usamos la clase .profile-nav (no :last-child, que no
  matcheaba de forma fiable). */
  .has-rail #nav-bar .navbar-print-fab {
    order: 1;
    margin: 0 !important;
    gap: 12px;
    position: static !important;
  }
  .has-rail #nav-bar .profile-nav {
    order: 2;
    display: flex;
    align-items: center;
    margin: 0 !important;
    position: static !important;
  }
  /* La ayuda no entra en esta fila */
  .has-rail #nav-bar .help-icon {
    display: none;
  }
  /* Reset de márgenes heredados de escritorio que causan solape */
  .has-rail #nav-bar .user-info-container .nav-link {
    margin: 0 !important;
  }
  /* Ahorrar espacio: en responsive solo el ícono de usuario (sin nombre) */
  .has-rail #nav-bar .user-name {
    display: none !important;
  }
  /* En responsive, el chip de edición muestra solo ícono + switch (sin texto) */
  .has-rail #nav-bar .edit-mode-toggle__text {
    display: none;
  }
  .has-rail #nav-bar .edit-mode-toggle {
    padding: 0 9px;
    gap: 7px;
  }
  .has-rail .loadingBar {
    top: 92px !important;
  }
}
/* El PrintFab trae estilos heredados (position:fixed, márgenes, z-index) en su
@media (max-width:980px) que sacaban del flujo al control de impresión y hacían
que los íconos del navbar se solaparan entre 770–980px. En el navbar el PrintFab
siempre debe ser inline. */
#nav-bar .navbar-print-fab {
  position: static !important;
  z-index: auto !important;
}
/* Rango 769–980px: replicar el espaciado del cluster de escritorio (>=980px). */
@media only screen and (min-width: 769px) and (max-width: 980px) {
  #nav-bar .navbar-print-fab {
    margin: 0 12px 0 0 !important;
  }
  #nav-bar .navbar-print-fab .toggle-crud,
  #nav-bar .navbar-print-fab .print-fab {
    margin: 0 !important;
    transform: none !important;
  }
}
.bm-menu {
  top: 78px !important;
}
.bm-burger-button {
  top: 84px;
  left: 15px;
}
.navbar-nav .nav-link {
  color: white;
  text-align: left;
}
.section1 {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0;
  right: 0;
  box-sizing: border-box;
  background: #fff;
  /* background: -moz-linear-gradient(
    0deg,
    rgba(193, 193, 193, 1) 0%,
    rgba(227, 227, 227, 1) 10%,
    rgba(255, 255, 255, 1) 33%,
    rgba(255, 255, 255, 1) 70%,
    rgba(255, 255, 255, 1) 92%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(193, 193, 193, 1) 0%,
    rgba(227, 227, 227, 1) 10%,
    rgba(255, 255, 255, 1) 33%,
    rgba(255, 255, 255, 1) 70%,
    rgba(255, 255, 255, 1) 92%
  );
  background: linear-gradient(
    0deg,
    rgba(193, 193, 193, 1) 0%,
    rgba(227, 227, 227, 1) 10%,
    rgba(255, 255, 255, 1) 33%,
    rgba(255, 255, 255, 1) 70%,
    rgba(255, 255, 255, 1) 92%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#c1c1c1",endColorstr="#ffffff",GradientType=1); */
  /* padding-bottom: 2em; */
  /* margin-bottom: 300px; */
  /* margin-bottom: 60px; */
  transition: all 0.3s;
}
.section1.active {
  margin-left: 250px;
  padding-right: 250px;
}
/* .custom-margin-bottom { */
/* margin-bottom: 380px !important; */
/* } */
/* .sidebar-btn {
  position: fixed;
  top: 67px !important;
  left: 0;
  z-index: 1000;
  transition: all 0.3s;
}
.sidebar-btn-active {
  margin-left: 250px;
}
.sidebar-btn .btn-collapse {
  width: 25px;
  height: 25px;
  background: var(--header-color) !important;
  border: var(--header-color) !important;
}
.sidebar-btn .btn-collapse:hover {
  background: #14abd8 !important;
}
.sidebar-btn-icon {
  transform: translate(-25%, -10%);
} */
@media (max-width: 500px) {
  .router-container {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media only screen and (max-width: 600px) {
  .section1 {
    position: relative;
    width: 100%;
    min-height: 100vh;
    z-index: 10;
    padding: 5px;
    box-sizing: border-box;
    background: #fff;
    /* margin-bottom: 100px; */
    line-height: 30px;
    box-shadow: 0 2px 3px -2px rgb(0, 0, 0);
    transition: all 0.3s;
  }
}
.app-container {
  width: 100%;
  max-width: 100% !important;
  min-height: 100vh;
  padding: 0px !important;
  /* Fondo de página (estándar): gris azulado tenue, formal, que hace resaltar
     tarjetas y tablas blancas. */
  /* background: var(--kl-bg-page); */
  /* Se agrega un padding a la derecha e izquierda al contenedor para que exista una leve separacion entre el contenido y el borde de la pantalla */
  /* padding-right: 2px !important;
  padding-left: 2px !important; */
}
.router-container {
  width: 100% !important;
  /* padding-right: 10px; */
  /* padding-left: 10px; */
  margin-right: auto !important;
  margin-left: auto !important;
}
/* Clases above y below para mostrar los botones en el fondo de las celdas de las tablas. */
.above {
  position: relative;
  margin-bottom: 30px;
  padding-bottom: 5px;
  vertical-align: middle;
}
.below {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  -webkit-box-align: center;
}
.big-table-content {
  font-size: 8pt;
  text-align: justify;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.dirty {
  border-color: #5a5;
  background: #efe;
}
.dirty:focus {
  outline-color: #8e8;
}
.error {
  border-color: red;
  background: #fdd;
}
.input--error {
  border-color: red;
}
.input--error:focus {
  border-color: red;
}
.error-message {
  font-size: 8pt;
}
.error:focus {
  outline-color: #f99;
}
div.vue-go-top {
  width: 40px !important;
  height: 40px !important;
  background-color: var(--kl-color-primary) !important;
  bottom: calc(20px) !important;
}
ul,
li {
  margin-left: 0.5em;
}
.tooltip-inner {
  max-width: 230px !important;
  hyphens: none;
  -webkit-hyphens: none;
  -ms-hyphens: none;
  word-break: normal;
}
.div-header {
  display: none;
}
.logo-print {
  max-width: 195px;
  max-height: 55px;
  min-height: 55px;
  min-width: 55px;
}
.logo-print-curricular-mesh {
  max-width: 350px;
  max-height: 150px;
  min-height: 55px;
  min-width: 55px;
}
/* @media (min-width: 1920px) and (max-width: 2099px) {
  .app-container {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}

@media (min-width: 2100px) and (max-width: 2599px) {
  .app-container {
    padding-left: 10% !important;
    padding-right: 10% !important; 
  }
} */

/* 
Reglas globales para separación silábica correcta en español
- word-break: normal - Respeta las reglas normales de separación
- overflow-wrap: break-word - Permite romper palabras largas que no caben en el contenedor
- hyphens: auto - Aplica separación silábica automática según las reglas del idioma (requiere lang="es" en HTML)
- -webkit-hyphens y -ms-hyphens - Soporte para navegadores Webkit y Microsoft
Ejemplos: "Formación" se separa como "Forma-ción" en lugar de "Formac-ión"
*/
p,
span,
div,
td,
/* th, */
h1,
h2,
h3,
h4,
h5,
h6 {
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: auto;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
}

/* Desactivar separación silábica para encabezados de tabla */
th,
th div,
th strong,
th span,
div h1,
div h2,
div h3,
div h4,
h1 span,
h2 span,
h3 span,
h4 span,
button div {
  hyphens: none;
  -webkit-hyphens: none;
  -ms-hyphens: none;
}

/* Ocultar badge flotante de reCAPTCHA - la atribución se muestra en el ContactForm */
.grecaptcha-badge {
  visibility: hidden !important;
}

@media print {
  .div-header {
    display: flex !important;
    margin-right: auto !important;
    margin-left: 3% !important;
    margin-top: 0 !important;
  }
  #app {
    padding-top: 0 !important;
  }
  /* Al imprimir, el riel se oculta (noprint) pero su padding/offsets seguían
  corriendo el contenido a la derecha. Los reseteamos. */
  #app.has-rail {
    padding-left: 0 !important;
    padding-top: 0 !important;
  }
  .has-rail #nav-bar,
  body.kl-rail-expanded .has-rail #nav-bar {
    left: 0 !important;
  }
  body.kl-rail-expanded .has-rail {
    padding-left: 0 !important;
  }
  .noprint {
    display: none !important;
  }
  .section1 {
    min-height: 0 !important;
  }
  .app-container {
    min-height: 0 !important;
  }
}
</style>
